export const addDaysToDate = (days: number, date = new Date()) => {
  const innerDate = new Date(date)
  innerDate.setHours(0, 0, 0, 0)
  return new Date(innerDate.setDate(innerDate.getDate() + days))
}

export const addYearsToDate = (years: number, date = new Date()) => {
  const innerDate = new Date(date)
  innerDate.setHours(0, 0, 0, 0)
  innerDate.setFullYear(innerDate.getFullYear() + years)
  return new Date(innerDate.setDate(innerDate.getDate() - 1))
}

export const format = (
  date: Date | null,
  locale: string = 'es',
  options: Record<string, string> = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  }
) => {
  try {
    if (!date) return ''

    return new Intl.DateTimeFormat(locale, options).format(date)
  } catch (e) {
    // return new Intl.DateTimeFormat(locale, options).format(new Date(date))
    return ''
  }
}

export const isLeapYear = (year: number) => {
  return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0
}

export const maxDaysByMonth = (month: number, year: number) => {
  if ([1, 3, 5, 7, 8, 10, 12].includes(month)) {
    return 31
  }

  if (month === 2) {
    return isLeapYear(year) ? 29 : 28
  }

  return 30
}

export const areEquals = (dateA: Date | null, dateB: Date | null) => {
  if (!dateA || !dateB) return false

  return (
    dateA?.getDate() === dateB?.getDate() &&
    dateA?.getMonth() === dateB?.getMonth() &&
    dateA?.getFullYear() === dateB?.getFullYear()
  )
}

export const yearsToMs = (years: number): number => {
  return years * 365.25 * 24 * 60 * 60 * 1000 // includes leap years
}

export const diffBetweenTwoYearsMs = (dateStart: Date, dateEnd: Date = new Date()): number => {
  dateStart.setHours(0, 0, 0, 0)
  dateEnd.setHours(0, 0, 0, 0)
  return dateEnd.getTime() - dateStart.getTime()
}

export const notFutureDate = (date: Date): boolean => {
  const diffMilliseconds = diffBetweenTwoYearsMs(date, new Date())
  return diffMilliseconds >= 0
}

export const isBigger = (date: Date, years: number, startDate: Date = new Date()): boolean => {
  const yearDifference = startDate.getFullYear() - date.getFullYear()
  const hasPassedBirthday =
    startDate.getMonth() > date.getMonth() ||
    (startDate.getMonth() === date.getMonth() && startDate.getDate() >= date.getDate())

  return yearDifference > years || (yearDifference === years && hasPassedBirthday)
}

export const isSmaller = (date: Date, years: number, startDate: Date = new Date()): boolean => {
  const diffMilliseconds = diffBetweenTwoYearsMs(date, new Date(startDate))
  const yearsMilliseconds = yearsToMs(years)
  return diffMilliseconds < yearsMilliseconds
}

export const castToDate = (date: string | Date | null): Date | null => {
  if (date === null) return null

  const newDate = typeof date === 'string' ? new Date(date) : date
  if (isNaN(newDate.getTime())) return null

  return newDate
}

export const ddMMyyyyToDate = (value: string): Date | null => {
  try {
    const d = value.split('/')
    return new Date(parseInt(d[2]), parseInt(d[1]) - 1, parseInt(d[0]))
  } catch (err) {
    return null
  }
}

export const dateToddMMyyyy = (value: Date): string => {
  try {
    return `${value.getDate()}/${value.getMonth() + 1}/${value.getFullYear()}`
  } catch (err) {
    return ''
  }
}

export const convertDateToAge = (birthDate: Date, referenceDate: Date = new Date()): number => {
  const age = referenceDate.getFullYear() - birthDate.getFullYear()
  const month = referenceDate.getMonth() - birthDate.getMonth()

  if (month < 0 || (month === 0 && birthDate.getDate() < referenceDate.getDate())) {
    return age - 1
  }

  return age
}

export function daysBetweenTwoDates(initDate: Date, endDate: Date): number {
  const unDia = 1000 * 60 * 60 * 24
  const diferenciaMs = endDate.getTime() - initDate.getTime()
  return Math.floor(diferenciaMs / unDia)
}

export function isBiggerActuarial(birthDate: string, yearLimit: number): boolean {
  const today = new Date()
  const innerDate = ddMMyyyyToDate(birthDate)!
  const age = today.getFullYear() - innerDate.getFullYear()

  if (age > yearLimit) return true
  if (age < yearLimit) return false

  if (today.getMonth() > innerDate.getMonth()) return true
  if (today.getMonth() < innerDate.getMonth()) return false

  return today.getDate() > innerDate.getDate()
}

export function addMonthsToDate(months: number, date: Date | string = new Date()): Date {
  const d = new Date(date)
  d.setMonth(d.getMonth() + months)
  return d
}
